import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { JWTService } from 'mds-ui/app/modules/fingerprint/fingerprint-summary/service/jwt.service';
import { HandleError, HttpErrorHandler } from 'mds-ui/app/shared/service/http-error-handler.service';
import { environment } from 'mds-ui/environments/environment';
import { catchError } from 'rxjs/operators';
import 'rxjs/Rx'; // use this line if you want to be lazy, otherwise:
import { Observable } from 'rxjs/Rx';
import { ApplicantVO, FileResponseVO, ApplicantSearchVO, Reports } from 'mds-ui/app/modules/fingerprint/models/application';

@Injectable()
export class MtpApplicationService {
    private handleError: HandleError;
    public applicant: ApplicantVO;
    public fileResponse: FileResponseVO;
    public applicantSearchVO: ApplicantSearchVO;
    public reports: Reports;
    flag: boolean;
    constructor(private _http: HttpClient, private httpErrorHandler: HttpErrorHandler,
        private jwtService: JWTService) {
        this.handleError = httpErrorHandler.createHandleError('LocationService');
    }

    private httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json',
            "Cache-Control": "no-cache",
            Pragma: "no-cache"
        })
    };

    applicantInfoInit() {
        this.applicant = new ApplicantVO();
        this.reports = new Reports();
    }



    getApplicantById(id: number, reqUser: string): Observable<ApplicantVO[]> {
        return this._http.get<ApplicantVO[]>(
            environment.getApplicantUrl + id + "?userName=" + reqUser, this.httpOptions)
            .pipe(
                catchError(this.handleError('getApplicantById', []))
            );
    }


    saveLiveScanRequest(applicant: ApplicantVO): Observable<any> {
        return this._http.post<ApplicantVO[]>(environment.savelivescanrequestURL, applicant, this.httpOptions)
            .pipe(catchError(this.handleError('saveLiveScanRequest()', [])));
    }

    getApplicantByPersonId(id: number, reqUser: string): Observable<ApplicantVO[]> {
        return this._http.get<ApplicantVO[]>(
            environment.getMtpApplicantByIdUrl + "person/" + id + "?userName=" + reqUser, this.httpOptions)
            .pipe(
                catchError(this.handleError('getApplicantByPersonId', []))
            );
    }

    downloadBCIA8016Form(applicantId: number, userName: string): Observable<FileResponseVO[]> {
        return this._http.get<FileResponseVO[]>(
            environment.downloadBCIA8016FormUrl + applicantId + "?userName=" + userName, this.httpOptions)
            .pipe(
                catchError(this.handleError('downloadBCIA8016Form', []))
            );
    }

}